import { createSelector } from 'reselect'
import { IPlayerData } from '../../../helpers/data/player'
import viewTypes from '../../../helpers/enums/views'
import { IWinnerPlayerData } from '../../../helpers/data/winnerPlayer'
import { ICharacterData } from '../../../helpers/data/characterData'
import userIdSelector from '../app/userIdSelector'
import hideStudentNamesSelector from '../app/hideStudentNamesSelector'
import hiddenNameText from '../../../helpers/enums/hiddenNameText'
import charactersSelector from '../app/charactersSelector'
import skinSelector from '../app/skinSelector'
import gameSettingsSelector from '../app/gameSettingsSelector'
import settingsHelper from '../../../helpers/utils/settings'
import settingsEnums from '../../../helpers/enums/settings'
import { IStore } from '../../reducers/index'

const playersSelector = (state: IStore) => {
	const players = state.game.participants
	const characters = charactersSelector(state)
	const shouldHideStudentNames = hideStudentNamesSelector(state)
	const playerUID = userIdSelector(state)

	const winnerPlayers = players
		.filter((player: IPlayerData) => [viewTypes.WINNERS, viewTypes.GAME].includes(player.view.type))
		.sort((a: IPlayerData, b: IPlayerData) => {
			return b.score - a.score
		})
		.filter((player: IPlayerData, index: number) => index < 3)
		.map((player: IPlayerData): IWinnerPlayerData => {
			const characterData =
				characters.find((character: ICharacterData) => character.id === player.avatar) || characters[0]
			return {
				label: player.nickname,
				nickname: shouldHideStudentNames && player.deviceUid !== playerUID ? hiddenNameText : player.nickname,
				playerUID: player.deviceUid,
				score: player.score,
				avatarId: player.avatar,
				flagAsset: characterData.flag,
				podiumAsset: characterData.podium,
				characterName: characterData.name || '',
			}
		})
	return winnerPlayers
}

export default createSelector(playersSelector, skinSelector, gameSettingsSelector, (players, skin, gameSettings) => {
	const isTimerDisabled = settingsHelper.getSettingValue(gameSettings, settingsEnums.SETTING_TYPE_TIMER_DISABLED) ?? settingsEnums.SETTING_TIMER_DEFAULT
	return {
		players,
		skin: skin.winners,
		isTimerDisabled,
	}
})
